import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1125.000000 2436.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,2436.000000) scale(0.100000,-0.100000)" >
<path d="M0 20905 l0 -3455 5625 0 5625 0 0 3455 0 3455 -5625 0 -5625 0 0
-3455z"/>
<path d="M5308 17170 c-753 -72 -1428 -346 -2016 -818 -304 -244 -604 -578
-824 -917 -92 -141 -102 -161 -82 -169 9 -3 105 -6 214 -6 l199 0 99 133 c304
406 645 712 1062 952 213 123 352 185 615 275 367 126 719 177 1135 167 237
-7 374 -21 581 -63 562 -112 1115 -388 1549 -773 146 -131 169 -153 277 -273
249 -276 445 -569 594 -887 41 -87 52 -102 66 -96 78 34 107 38 162 27 108
-23 169 -109 157 -220 -9 -74 -27 -104 -92 -154 -31 -24 -65 -50 -75 -58 -19
-15 -19 -17 11 -145 86 -355 114 -616 107 -980 -6 -333 -36 -558 -112 -852
-162 -621 -478 -1175 -929 -1626 -234 -235 -443 -392 -823 -618 -90 -53 -160
-98 -158 -101 3 -3 -1 -11 -10 -18 -8 -7 -15 -18 -15 -25 0 -12 -126 -101
-190 -135 -14 -7 -30 -21 -37 -30 -6 -9 -30 -22 -52 -30 -22 -7 -50 -24 -62
-36 -24 -26 -58 -32 -61 -11 -1 6 -2 39 -2 72 l-1 60 -35 -1 c-55 -1 -244 -54
-258 -72 -21 -26 -12 -296 10 -318 28 -29 53 -25 373 61 237 63 673 250 860
369 187 118 245 157 335 225 47 36 112 87 145 115 32 28 73 62 89 76 77 65
256 244 324 325 42 50 79 92 82 95 17 14 177 232 238 322 202 304 375 662 475
988 139 451 191 788 190 1235 0 445 -48 776 -174 1192 -242 803 -735 1511
-1400 2008 -519 389 -1098 626 -1749 716 -162 23 -635 34 -792 19z"/>
<path d="M5375 16614 c-247 -25 -480 -69 -675 -129 -715 -220 -1328 -684
-1764 -1334 -42 -63 -76 -118 -76 -123 0 -4 172 -8 383 -9 210 0 408 -4 440
-8 55 -7 62 -11 110 -64 29 -31 64 -71 78 -89 15 -18 62 -73 106 -123 104
-118 218 -250 268 -309 22 -27 50 -57 63 -69 12 -11 22 -25 22 -30 0 -5 15
-26 34 -46 43 -46 102 -114 192 -221 39 -47 85 -100 103 -119 17 -18 35 -39
39 -46 6 -11 49 -60 167 -194 61 -70 147 -172 177 -211 15 -19 53 -63 85 -98
32 -34 74 -83 93 -109 19 -25 63 -75 98 -112 34 -36 62 -70 62 -74 0 -5 22
-32 48 -60 42 -44 291 -332 314 -362 20 -26 77 -93 116 -134 23 -25 72 -82
108 -126 81 -97 173 -195 185 -195 22 0 49 45 74 126 15 49 37 105 47 125 l20
36 -37 48 c-25 33 -35 55 -31 70 4 16 -2 25 -27 38 -38 21 -105 84 -157 147
-19 23 -57 67 -85 97 -27 30 -58 68 -68 84 -11 16 -22 29 -27 29 -4 0 -54 57
-111 127 -57 70 -120 143 -139 163 -36 37 -116 131 -228 268 -61 74 -114 137
-177 207 -16 18 -49 57 -73 87 -23 29 -67 83 -97 120 -30 37 -67 89 -81 115
-15 27 -32 55 -39 63 -28 36 -117 233 -141 315 -38 128 -45 363 -15 510 30
147 34 162 81 260 78 163 195 314 311 402 211 158 321 199 646 239 61 7 322
-30 366 -53 15 -7 38 -31 52 -53 14 -21 35 -44 47 -51 50 -26 194 -126 216
-149 54 -59 112 -135 112 -146 0 -6 12 -25 28 -42 31 -34 50 -61 58 -82 3 -8
12 -27 20 -42 8 -14 14 -32 14 -39 0 -7 6 -20 14 -28 39 -45 85 -329 71 -438
-10 -81 -23 -87 -203 -83 -330 7 -344 5 -389 -47 -30 -35 -34 -37 -46 -21 -8
11 -17 58 -21 118 -8 127 -44 210 -118 272 -60 50 -106 67 -183 68 -78 0 -168
-40 -209 -95 -53 -69 -86 -145 -86 -197 0 -71 91 -251 179 -354 14 -16 42 -50
61 -74 19 -23 46 -55 60 -69 14 -14 63 -71 109 -126 46 -55 87 -101 92 -103 4
-2 31 -35 60 -73 28 -38 55 -69 60 -69 5 0 15 -13 24 -30 24 -47 93 -53 132
-11 10 11 50 41 89 68 93 64 117 82 169 123 24 19 60 46 80 60 20 14 69 50
110 80 41 30 109 80 152 110 43 29 98 70 123 90 25 20 55 42 66 50 12 8 70 50
128 93 58 42 110 77 115 77 5 0 11 3 13 8 2 4 41 35 88 69 47 35 125 93 173
130 117 90 180 123 239 123 81 0 107 -15 151 -91 31 -52 35 -105 11 -150 -20
-40 -83 -109 -99 -109 -6 0 -20 -9 -31 -21 -10 -12 -32 -28 -48 -36 -26 -14
-78 -52 -221 -163 -51 -40 -174 -129 -347 -253 -76 -54 -140 -102 -143 -107
-4 -6 -39 -31 -78 -57 -40 -26 -145 -101 -234 -167 -89 -67 -191 -143 -227
-169 -96 -69 -102 -81 -89 -177 7 -53 17 -87 32 -106 11 -15 21 -33 21 -40 0
-8 5 -14 11 -14 5 0 17 -16 25 -35 19 -47 39 -53 72 -23 15 14 41 34 57 44 17
10 47 33 68 51 20 18 40 33 45 33 4 0 23 14 42 30 19 17 66 51 104 77 39 26
78 55 88 65 10 10 23 18 28 18 6 0 18 8 28 18 11 11 40 34 67 53 26 19 61 44
79 57 17 12 44 31 59 41 16 10 59 42 95 70 37 28 128 95 202 150 74 54 151
111 170 125 49 37 219 160 255 186 107 75 223 160 241 176 12 11 28 24 36 29
8 6 34 23 57 39 53 37 119 48 179 30 25 -8 51 -19 58 -25 39 -32 -1 71 -118
306 -435 870 -1259 1524 -2180 1729 -234 52 -375 67 -653 71 -143 2 -278 1
-300 -1z"/>
<path d="M2311 15166 c-22 -27 -143 -281 -198 -416 -272 -674 -355 -1455 -232
-2195 149 -896 622 -1745 1299 -2330 390 -338 896 -616 1340 -738 175 -48 215
-58 310 -77 306 -61 441 -73 820 -68 181 2 335 9 348 14 22 9 23 11 6 25 -14
11 -74 15 -298 19 -257 5 -286 8 -336 27 -30 12 -116 43 -190 69 -74 26 -169
65 -210 87 -95 50 -258 158 -317 208 -55 48 -86 64 -244 128 -586 235 -1070
600 -1457 1098 -490 630 -752 1401 -752 2213 0 545 98 1014 315 1505 30 68 55
133 55 144 0 23 -1 25 -110 151 -41 48 -86 101 -100 119 -28 35 -33 37 -49 17z"/>
<path d="M2767 14862 c-36 -40 -179 -375 -237 -557 -65 -203 -118 -465 -146
-709 -23 -205 -15 -640 15 -836 62 -410 157 -721 324 -1058 476 -961 1347
-1623 2372 -1802 112 -19 369 -38 335 -24 -8 4 -87 31 -175 61 -88 31 -172 64
-187 74 -14 11 -30 19 -36 19 -17 0 -234 149 -301 208 -110 96 -225 214 -269
277 -23 33 -55 78 -72 100 -16 22 -34 49 -39 61 -5 12 -23 43 -39 70 -30 49
-58 116 -104 249 -43 122 -55 167 -73 265 -9 52 -21 109 -26 126 -5 17 -9 142
-9 278 l0 247 25 25 25 25 365 -3 c334 -3 366 -4 382 -21 16 -16 19 -46 24
-280 5 -230 8 -271 27 -334 25 -84 84 -211 123 -268 42 -62 188 -208 248 -249
60 -40 90 -43 106 -9 8 15 10 165 9 475 -1 249 -3 464 -3 478 -1 32 -36 80
-185 255 -47 55 -91 107 -98 115 -93 110 -144 166 -155 173 -7 5 -24 25 -37
45 -14 20 -78 98 -143 173 -65 75 -127 147 -137 160 -28 35 -155 180 -183 209
-14 14 -72 81 -129 150 -58 69 -129 152 -158 185 -28 33 -85 101 -126 150 -41
50 -109 128 -152 174 -43 46 -78 89 -78 95 0 6 -18 29 -39 51 -52 52 -116 125
-176 200 -56 70 -268 317 -334 390 -73 81 -135 155 -145 173 -5 9 -30 40 -55
68 -91 100 -117 131 -206 234 -122 143 -110 132 -128 112z"/>
<path d="M8687 14360 c-3 -8 -10 -33 -16 -55 -12 -46 -47 -82 -142 -148 -37
-25 -98 -69 -137 -99 -38 -29 -82 -62 -98 -73 -15 -11 -60 -43 -99 -72 -38
-28 -88 -65 -110 -80 -22 -16 -101 -74 -175 -129 -148 -110 -243 -179 -305
-221 -22 -15 -63 -46 -92 -70 -28 -24 -55 -43 -61 -43 -5 0 -29 -17 -53 -38
-24 -21 -55 -45 -69 -55 -39 -27 -92 -65 -131 -95 -20 -15 -74 -54 -120 -86
-121 -86 -189 -145 -189 -165 0 -10 9 -26 20 -36 11 -10 20 -22 20 -26 0 -11
57 -94 75 -109 8 -7 22 -27 31 -45 8 -18 23 -35 33 -38 10 -2 35 -38 55 -78
21 -41 60 -110 87 -154 27 -44 51 -87 54 -95 4 -8 20 -46 37 -85 17 -38 38
-104 46 -145 8 -41 18 -84 23 -95 37 -92 71 -367 58 -470 -4 -33 -8 -93 -8
-133 -1 -41 -8 -89 -17 -110 -8 -20 -19 -64 -24 -97 -10 -73 -33 -144 -65
-208 -14 -26 -25 -57 -25 -70 0 -12 -9 -33 -20 -47 -11 -14 -20 -32 -20 -40 0
-8 -23 -49 -50 -89 -28 -41 -50 -81 -50 -88 0 -7 -21 -34 -47 -61 -27 -26 -54
-60 -62 -74 -17 -32 -114 -128 -130 -128 -6 0 -11 -7 -11 -16 0 -9 -9 -18 -20
-21 -11 -3 -20 -12 -20 -19 0 -8 -4 -14 -10 -14 -5 0 -10 -5 -10 -11 0 -15
-33 -41 -111 -89 -37 -23 -75 -50 -84 -60 -10 -11 -23 -20 -29 -20 -7 0 -36
-16 -65 -35 -30 -19 -57 -32 -61 -30 -4 2 -8 205 -9 450 l-1 446 36 33 c24 22
37 42 37 60 0 17 10 35 28 51 16 13 29 32 29 42 0 10 7 26 15 37 39 52 77 246
79 401 1 131 -18 236 -49 275 -7 8 -15 39 -19 68 -7 58 -38 117 -68 133 -28
15 -55 -13 -111 -116 -38 -71 -49 -83 -97 -107 -29 -16 -66 -28 -80 -28 -15 0
-34 -8 -43 -18 -16 -17 -17 -98 -17 -960 l0 -942 28 0 c37 0 230 51 382 101
642 212 1219 646 1627 1224 438 621 656 1377 622 2155 -12 275 -59 561 -135
824 -40 136 -50 160 -57 136z"/>
<path d="M8090 7519 c-53 -21 -94 -82 -106 -158 -5 -34 -11 -42 -33 -48 -52
-12 -70 -42 -21 -35 37 5 37 5 6 -157 -23 -117 -24 -151 -6 -151 18 0 40 13
35 20 -8 13 46 284 58 292 16 10 124 10 131 0 2 -4 -1 -39 -9 -77 -14 -77 -8
-107 25 -125 15 -8 30 -8 54 0 34 11 104 73 133 117 8 12 19 23 23 23 4 0 7
-32 6 -71 -1 -83 15 -102 39 -46 23 55 85 159 113 190 47 50 62 33 62 -66 0
-144 41 -182 119 -111 39 34 40 35 51 15 26 -49 123 -14 179 64 l21 30 0 -41
c0 -48 -8 -56 -102 -108 -68 -37 -108 -76 -108 -104 0 -9 10 -26 22 -39 l21
-23 -2448 0 -2448 0 7 68 c10 111 11 112 65 105 64 -7 121 22 156 80 53 91 19
197 -64 197 -20 0 -46 -7 -57 -15 -30 -23 -34 -18 -28 30 l7 44 -38 -10 c-21
-6 -51 -8 -67 -5 -24 5 -29 3 -26 -12 2 -11 15 -19 36 -22 37 -6 37 -5 28 -64
-13 -82 -142 -211 -192 -192 -13 5 -15 15 -10 49 4 23 9 68 13 100 6 58 5 59
-18 55 -20 -2 -24 -10 -27 -38 -1 -19 -7 -61 -12 -92 -12 -63 -4 -90 31 -108
32 -18 80 4 138 62 28 29 51 47 51 40 0 -6 -9 -58 -20 -114 -11 -57 -20 -115
-20 -130 l0 -28 -1930 0 -1930 0 0 -3455 0 -3455 5625 0 5625 0 0 3455 0 3455
-525 0 -525 0 0 26 c0 15 5 55 12 90 l11 63 47 -6 c111 -13 205 93 179 205
-15 67 -74 91 -141 56 l-31 -16 7 40 6 40 -70 -1 c-38 -1 -70 -4 -70 -7 0 -15
27 -30 53 -30 29 0 29 -1 23 -42 -13 -80 -127 -218 -180 -218 -33 0 -36 15
-19 103 17 84 14 107 -17 107 -15 0 -20 -7 -20 -26 0 -15 -5 -55 -11 -89 -14
-74 -7 -113 24 -124 40 -15 77 0 133 54 36 36 54 48 54 37 0 -10 -10 -72 -22
-139 l-23 -123 -624 0 -624 0 34 23 c42 28 79 98 79 152 0 39 3 43 59 83 l59
41 6 -43 c18 -119 153 -120 280 -2 25 23 48 41 49 39 2 -1 -1 -28 -6 -58 -7
-37 -7 -59 0 -66 15 -15 41 0 48 29 10 40 69 132 109 171 25 24 41 32 56 28
30 -8 50 2 50 24 0 14 7 19 25 19 14 0 25 -1 25 -2 0 -2 -7 -28 -15 -58 -8
-30 -15 -81 -15 -113 0 -48 4 -62 25 -82 13 -14 29 -25 34 -25 39 0 121 59
121 88 0 9 -10 5 -31 -12 -34 -29 -84 -35 -93 -10 -11 28 -6 109 9 162 l16 52
80 0 c68 0 88 4 127 26 50 27 92 62 92 75 0 11 -92 -38 -102 -54 -4 -7 -40
-13 -93 -16 -94 -3 -100 1 -70 59 13 26 13 30 1 30 -31 0 -48 -14 -63 -51 -12
-32 -20 -39 -43 -39 -67 0 -133 -45 -191 -132 -23 -33 -43 -58 -45 -56 -2 2 2
32 8 66 8 42 8 66 1 73 -15 15 -43 0 -43 -23 0 -47 -91 -147 -164 -182 -67
-32 -126 -13 -126 40 0 19 5 24 28 24 63 1 152 65 152 111 0 31 -36 59 -75 59
-49 0 -97 -26 -125 -68 -14 -19 -52 -56 -85 -80 -49 -36 -61 -41 -63 -27 -3
15 12 119 25 173 4 18 1 22 -16 22 -12 0 -24 -6 -27 -14 -4 -11 -18 -13 -58
-9 -84 9 -137 -30 -185 -137 -24 -54 -39 -73 -68 -88 -31 -17 -43 9 -43 93 0
36 -7 81 -14 100 -30 70 -99 34 -171 -89 -15 -25 -28 -46 -30 -46 -1 0 -2 33
-1 73 1 65 -1 72 -19 72 -14 0 -21 -9 -26 -32 -11 -57 -117 -177 -166 -189
-43 -11 -48 7 -29 101 9 47 14 90 11 96 -4 6 -36 8 -89 3 -46 -4 -86 -3 -89 2
-9 15 28 142 48 164 21 24 57 26 75 5 16 -20 26 -19 34 2 14 35 -41 53 -94 32z
m880 -205 c13 -12 12 -18 -5 -49 -27 -52 -101 -117 -128 -113 -52 7 -19 139
43 174 28 15 67 10 90 -12z m348 -7 c4 -34 -43 -82 -89 -92 -39 -9 -43 -4 -29
39 24 74 111 113 118 53z m-5224 -9 c20 -29 20 -100 1 -138 -28 -55 -112 -75
-144 -36 -18 21 14 157 42 178 32 25 82 23 101 -4z m6301 -8 c41 -80 -13 -185
-96 -185 -59 0 -65 12 -51 98 14 84 41 117 97 117 28 0 37 -6 50 -30z m-1435
-230 c0 -92 -75 -156 -130 -112 -23 18 -23 22 -10 46 12 24 112 96 132 96 4 0
8 -14 8 -30z m-1339 -6699 c24 -30 24 -62 0 -92 l-19 -24 -1955 -3 c-1269 -1
-1964 1 -1981 8 -55 21 -59 100 -6 127 20 10 424 12 1983 10 l1959 -2 19 -24z"/>
<path d="M2510 7510 c0 -14 26 -30 47 -30 28 0 29 -14 6 -130 -12 -64 -25 -98
-52 -137 -33 -48 -75 -83 -100 -83 -28 0 -30 83 -6 198 7 29 6 32 -18 32 -20
0 -26 -6 -31 -32 -8 -46 -100 -186 -130 -199 -58 -27 -68 8 -37 128 19 71 15
93 -15 93 -15 0 -17 -7 -39 -116 -16 -76 -17 -96 -6 -122 29 -70 107 -40 177
69 l29 44 5 -51 c6 -62 23 -84 63 -84 24 0 42 11 79 50 44 46 48 48 48 25 0
-14 13 -39 29 -57 71 -79 205 -14 218 106 5 45 7 47 32 41 14 -3 41 -1 59 4
32 10 33 9 58 -42 16 -31 22 -53 16 -55 -22 -7 -75 -47 -86 -64 -17 -29 5 -53
51 -56 32 -2 47 3 72 23 26 22 31 34 31 69 0 35 4 44 29 59 39 23 41 22 41
-13 0 -38 24 -86 49 -100 29 -15 88 -12 128 7 19 9 59 41 89 72 l55 55 -7 -66
c-7 -67 0 -84 29 -72 8 3 17 18 20 33 8 39 69 140 105 174 24 23 36 28 59 23
33 -8 59 13 49 39 -17 45 -100 -3 -158 -90 -23 -36 -44 -62 -46 -60 -3 2 1 32
7 66 14 68 7 85 -29 74 -13 -4 -19 -12 -16 -22 15 -37 -99 -172 -168 -198 -40
-15 -46 -15 -74 -1 -35 18 -42 33 -42 87 0 63 36 118 87 133 17 6 29 1 47 -18
28 -31 32 -32 46 -7 15 29 -12 51 -64 51 -51 0 -82 -20 -174 -109 -35 -33 -68
-61 -73 -61 -5 0 -20 22 -33 49 -25 48 -25 49 -6 66 23 21 26 53 6 61 -22 8
-55 -14 -62 -42 -7 -28 -31 -44 -68 -44 -27 0 -76 19 -76 30 0 3 -18 17 -41
29 -28 16 -44 20 -51 13 -16 -16 -2 -41 32 -60 17 -9 33 -27 36 -40 10 -35 -5
-89 -32 -122 -48 -56 -124 -31 -124 41 0 14 14 93 30 174 17 81 30 154 30 160
0 9 -20 12 -65 11 -36 0 -65 -3 -65 -6z m460 -394 c0 -30 -24 -56 -51 -56 -34
0 -35 31 -3 57 37 29 54 29 54 -1z"/>
<path d="M1934 7459 c-41 -12 -74 -49 -80 -90 -5 -32 0 -41 65 -113 81 -89 90
-120 45 -155 -53 -42 -144 -15 -144 41 0 24 -12 23 -28 -2 -24 -40 26 -90 91
-90 84 0 147 52 147 122 0 36 -7 47 -65 107 -70 73 -83 112 -47 144 26 24 87
22 112 -3 l20 -20 0 25 c0 39 -49 54 -116 34z"/>
<path d="M4297 7452 c-8 -9 -20 -29 -26 -44 -8 -21 -17 -27 -47 -30 -50 -4
-58 -28 -10 -28 41 0 40 3 21 -70 -8 -30 -15 -79 -15 -108 0 -43 5 -58 25 -77
13 -14 29 -25 34 -25 39 0 121 59 121 88 0 9 -10 5 -31 -12 -41 -35 -86 -35
-95 0 -7 29 1 110 16 167 l11 37 79 0 c61 0 89 5 122 22 43 21 98 66 98 79 0
9 -93 -39 -102 -54 -4 -7 -39 -13 -93 -16 -78 -3 -85 -2 -85 16 0 11 7 28 15
39 8 10 15 22 15 27 0 14 -37 7 -53 -11z"/>
<path d="M6117 7459 c-9 -5 -24 -25 -31 -44 -12 -29 -20 -34 -52 -37 -51 -4
-58 -28 -9 -28 l37 0 -7 -37 c-8 -46 -47 -105 -94 -144 -46 -38 -78 -38 -87
-2 -7 26 8 139 22 178 6 16 3 17 -22 11 -32 -8 -31 -8 -95 0 -61 8 -102 -14
-139 -72 -49 -77 -51 -170 -5 -200 37 -24 99 15 155 98 l25 38 7 -46 c7 -49
31 -84 58 -84 19 0 99 49 119 73 20 25 31 21 31 -10 1 -42 32 -76 68 -76 41 0
112 47 112 74 0 20 -1 20 -31 -5 -33 -28 -68 -33 -87 -14 -17 17 -15 77 4 153
l16 65 87 0 c79 0 111 9 111 30 0 3 -36 3 -81 1 -94 -4 -107 4 -85 47 9 17 16
33 16 37 0 8 -23 5 -43 -6z m-312 -141 c14 -6 25 -17 25 -24 0 -20 -111 -163
-132 -170 -10 -3 -25 0 -33 6 -29 24 -9 136 31 181 20 22 69 25 109 7z"/>
<path d="M3768 7432 c-23 -10 -38 -24 -38 -34 0 -26 21 -22 58 11 49 45 43 51
-20 23z"/>
<path d="M8244 7435 c-10 -8 -27 -15 -36 -15 -19 0 -26 -40 -7 -40 14 0 79 50
79 61 0 13 -14 11 -36 -6z"/>
<path d="M4813 7360 c-3 -11 -14 -20 -25 -20 -46 0 -105 -49 -127 -107 -19
-46 -106 -125 -134 -121 -19 3 -22 9 -21 48 1 25 5 71 9 103 8 57 8 57 -19 57
-23 0 -26 -4 -26 -33 0 -19 -5 -59 -11 -90 -14 -70 -6 -105 27 -117 37 -14 67
-3 120 43 31 27 49 37 52 29 10 -30 54 -70 85 -76 86 -16 169 52 186 154 l6
34 60 -1 c33 -1 59 -5 59 -10 -1 -4 -5 -44 -9 -89 -6 -71 -5 -82 10 -88 21 -8
35 0 35 21 0 23 76 157 110 193 16 18 35 30 42 28 8 -3 17 -40 23 -105 10
-105 23 -133 59 -133 36 0 112 85 160 177 33 65 -2 40 -51 -37 -86 -132 -113
-129 -122 12 -6 101 -18 128 -56 128 -34 0 -70 -34 -115 -108 l-40 -67 0 78
c0 76 -1 78 -22 75 -15 -2 -24 -11 -26 -25 -3 -20 -9 -23 -53 -23 -42 0 -54 5
-87 35 -21 19 -51 39 -66 45 -24 9 -29 8 -33 -10z m51 -63 c15 -11 18 -24 14
-69 -5 -63 -36 -115 -74 -124 -94 -24 -135 89 -62 172 24 27 38 34 67 34 21 0
45 -6 55 -13z"/>
<path d="M6863 7362 c-3 -12 -16 -22 -35 -26 -124 -25 -162 -199 -54 -250 43
-20 61 -20 112 3 49 22 82 66 98 127 6 25 15 45 19 45 4 -1 27 -1 51 -1 l43 0
-8 -42 c-19 -98 -3 -141 52 -141 25 0 41 10 78 50 25 28 54 61 63 74 l17 24 1
-45 c0 -58 22 -90 61 -90 23 0 42 12 81 51 27 27 52 49 53 47 2 -2 -1 -25 -7
-52 -8 -39 -7 -50 3 -57 23 -15 26 -11 63 64 19 40 54 94 77 121 38 43 45 47
75 41 27 -5 35 -2 44 15 14 27 5 40 -27 40 -37 0 -84 -40 -133 -112 l-43 -63
6 47 c4 27 9 59 13 72 4 16 1 25 -10 29 -27 11 -46 -4 -46 -35 0 -52 -101
-173 -138 -166 -30 6 -32 75 -6 196 6 29 4 32 -17 32 -20 0 -27 -8 -37 -42
-17 -52 -94 -173 -121 -187 -11 -6 -29 -11 -40 -11 -26 0 -28 32 -5 131 18 77
14 99 -15 99 -14 0 -21 -8 -23 -27 -3 -24 -8 -29 -37 -31 -50 -5 -77 5 -119
42 -49 44 -82 55 -89 28z m62 -72 c34 -38 0 -155 -52 -179 -58 -27 -113 8
-113 71 0 38 27 95 54 113 30 22 89 19 111 -5z"/>
<path d="M6656 7348 c-2 -7 -9 -33 -16 -58 -12 -45 -54 -137 -70 -153 -4 -5
-18 22 -30 60 -38 116 -48 133 -81 133 -34 0 -35 -3 -9 -40 20 -28 61 -130 74
-182 11 -49 -77 -128 -144 -128 -23 0 -30 -4 -30 -20 0 -43 53 -33 123 22 78
62 234 308 225 356 -4 20 -37 29 -42 10z"/>
<path d="M1338 7142 c-12 -2 -18 -13 -18 -33 0 -26 4 -29 30 -29 26 0 30 3 30
29 0 30 -13 40 -42 33z"/>
<path d="M1497 7133 c-12 -25 0 -48 26 -51 24 -3 27 0 27 27 0 26 -4 31 -24
31 -14 0 -27 -3 -29 -7z"/>
<path d="M1664 7113 c1 -23 6 -29 29 -31 24 -3 27 0 27 27 0 27 -3 31 -29 31
-24 0 -28 -4 -27 -27z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
